export default class _Model {

  constructor(json) {
    this.rawData = json;
  }

  static getOrDefault(data, field, defaultValue) {
    return field in (data || {}) ? data[field] : defaultValue;
  }

  static getMappedOrDefault(data, field, defaultValue, mapper) {
    return field in (data || {}) && data[field] ? mapper(data[field]) : defaultValue;
  }

  static getMappedOrDefaultWithUndefined(data, field, defaultValue, mapper) {
    return field in (data || {}) ? mapper(data[field]) : defaultValue;
  }

}
